import React from "react";
import { FichasData } from "../../../data/fichas.data";

interface Props {
  car: any;
  setShowGaleryMenu: (boolean: any) => void;
  setShowPDFMenu: (value: boolean) => void
}

const SidebarFooter: React.FC<Props> = ({ car, setShowGaleryMenu, setShowPDFMenu}) => {

  const [ficha, setFicha] = React.useState<any>(null);
  React.useEffect(() => {
      const fichasData: any = FichasData();
      setFicha(fichasData[car.id]);
    }, [car]);
  
    const openURL = (url: string) => {
      window.open(url, "_blank", "noopener,noreferrer");
    };

  return (
    <div className="studio-sidebar-options">
      {/* setShowPDFMenu(true) */}
      <div className='studio-sidebar-options-button' onClick={() => {openURL(ficha.url_catalog)}}>
        <div className='studio-sidebar-options-text'>Ficha Técnica</div>
      </div>
      <div className='studio-sidebar-options-button' onClick={() => {setShowGaleryMenu(true)}}>
        <div className='studio-sidebar-options-text'>Galería</div>
      </div>
    </div>
  );
};

export default SidebarFooter;